import { render } from "./LoadingContent.vue?vue&type=template&id=6785b5a2&ts=true"
import script from "./LoadingContent.vue?vue&type=script&lang=ts"
export * from "./LoadingContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__